import { API_BASE, apiFetch } from "../../api/http";

export async function getCourtLinks(): Promise<Record<string, string>> {
  const res = await apiFetch(`${API_BASE}/api/courtLinks`);
  if (!res.ok) throw new Error(`Failed to load court links: ${res.status}`);
  return res.json();
}


